import React from 'react';
import { Link } from 'react-router-dom';
export function WritingPage() {
  const articles = [{
    id: 10,
    title: 'The Limits of Transformer Creativity',
    excerpt: 'Current AI systems, particularly transformer-based models, act as powerful force multipliers for creative individuals while signaling the end of the line for human robots — the rote, procedural workers whose output can be fully automated.',
    date: 'October 10, 2024',
    category: 'Technology',
    slug: 'limits-transformer-creativity'
  }, {
    id: 9,
    title: 'New Formula for Slowing Aging and Achieving Optimal Health',
    excerpt: 'This integrative approach emphasizes a synergy of key nutrients and microbial balance as the foundation for long-term health, immune resilience, and healthy aging.',
    date: 'October 5, 2023',
    category: 'Biology',
    slug: 'new-formula-slowing-aging-optimal-health'
  }, {
    id: 8,
    title: 'The Gut Microbiome in Health and Disease',
    excerpt: 'Your body is home to trillions of bacteria, viruses, and fungi, collectively known as the microbiome. While some microbes are linked to disease, many are vital to your immune system, metabolism, cardiovascular health, and even mood.',
    date: 'September 10, 2023',
    category: 'Biology',
    slug: 'gut-microbiome-health-disease'
  }, {
    id: 7,
    title: 'ChatGPT limitations and the Web of the future',
    excerpt: 'The race is on to create AI agents that can perform tasks based on user input and access to information from various online sources. However, current AI systems like ChatGPT have significant limitations that prevent them from achieving true artificial general intelligence.',
    date: 'May 20, 2023',
    category: 'Technology',
    slug: 'chatgpt-limitations-web-future'
  }, {
    id: 6,
    title: 'Microbiota Reset & Biofilm Management – A New Therapeutic Framework',
    excerpt: 'After years of interdisciplinary research—combining microbial ecology, nutritional biochemistry, and early-stage clinical trials—we are nearing the launch of a novel gut-reset protocol targeting pathogenic biofilms.',
    date: 'August 15, 2023',
    category: 'Biology',
    slug: 'microbiota-reset-biofilm-management'
  }];
  const categories = ['All', 'Biology', 'Technology', 'Industry Analysis', 'Personal', 'Reviews', 'Opinion'];
  return <div className="w-full bg-white" data-id="element-701">
      <div className="container mx-auto px-4 py-16" data-id="element-702">
        <div className="max-w-4xl mx-auto" data-id="element-703">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-704">
            Writing
          </h1>
          <p className="text-lg text-gray-700 mb-8" data-id="element-705">
            A collection of my articles, essays, and other written work across
            various topics and publications.
          </p>
          <div className="mb-8 overflow-x-auto" data-id="element-706">
            <div className="flex space-x-2 min-w-max" data-id="element-707">
              {categories.map(category => <button key={category} className={`px-4 py-2 rounded-full text-sm font-medium ${category === 'All' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-708">
                  {category}
                </button>)}
            </div>
          </div>
          <div className="space-y-8" data-id="element-709">
            {articles.map(article => <article key={article.id} className="border-b border-gray-200 pb-8" data-id="element-710">
                <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-711">
                  <span data-id="element-712">{article.date}</span>
                  <span className="mx-2" data-id="element-713">•</span>
                  <span className="text-blue-600" data-id="element-714">{article.category}</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-715">
                  <Link to={`/writing/${article.slug}`} className="hover:text-blue-600" data-id="element-716">
                    {article.title}
                  </Link>
                </h2>
                <p className="text-gray-700 mb-4" data-id="element-717">{article.excerpt}</p>
                <Link to={`/writing/${article.slug}`} className="text-blue-600 font-medium hover:underline" data-id="element-718">
                  Read more
                </Link>
              </article>)}
          </div>
          <div className="mt-12 flex justify-center" data-id="element-719">
            <button className="px-6 py-3 bg-white text-blue-600 font-medium rounded-lg border border-blue-600 hover:bg-blue-50 transition-colors" data-id="element-720">
              Load more articles
            </button>
          </div>
          <div className="mt-16 bg-gray-50 rounded-lg p-8 border border-gray-200" data-id="element-721">
            <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-722">
              Subscribe to My Newsletter
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-723">
              Stay updated with my latest articles, essays, and thoughts
              delivered directly to your inbox.
            </p>
            <form className="flex flex-col sm:flex-row gap-3" data-id="element-724">
              <input type="email" placeholder="Enter your email" className="flex-grow px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" required data-id="element-725" />
              <button type="submit" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap" data-id="element-726">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>;
}